<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
      <!-- <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/RevLogo.png" width="125" height="30" alt="Logo" />
        <img class="navbar-brand-minimized" src="img/RevLogo.png" width="75" height="30" alt="Logo" />
      </b-link>-->

      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/seminars">Home</b-nav-item>
        <b-nav-item
          v-if="n_user.n_current_user.IsSU"
          class="px-3"
          to="/users"
          exact
          >Users</b-nav-item
        >
        <b-nav-item class="px-3" v-if="false">System Administration</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger"></b-badge>
        </b-nav-item>
        <!-- <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item>-->
        <!-- <b-nav-item class="d-md-down-none">
          <i class="icon-location-pin"></i>
        </b-nav-item>-->
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main" style="background-color: #fff">
        <Breadcrumb :list="list" />
        <div
          class="container-fluid"
          style="padding: 50px; padding-top: 25px; background-color: #fff"
        >
          <router-view></router-view>
        </div>
        <NotificationContainer />
      </main>
      <!-- <AppAside fixed>
        <DefaultAside />
      </AppAside>-->
    </div>
    <!-- <TheFooter>
    <!--footer-->
    <!-- <div>
        <a href="http://ssatechnologies.net">SSA Technologies Inc</a>
        <span class="ml-1">&copy; 2019</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1"></span>
        <a href="http://ssatechnologies.net"></a>
      </div>
    </TheFooter>-->
  </div>
</template>

<script>
import nav from "@/_nav";

import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import NotificationContainer from "@/components/NotificationContainer.vue";
import { mapState } from "vuex";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    NotificationContainer,
  },
  data() {
    return {
      nav: nav.items,
    };
  },
  computed: {
    ...mapState(["n_user"]),
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
  },
};
</script>
